// extracted by mini-css-extract-plugin
module.exports = {"badge":"PlanStatusBadge_badge__RJRsu","info":"PlanStatusBadge_info__4hDl1","onGradient":"PlanStatusBadge_onGradient__aUs_b"};